import ParallelInfo from './ParallelInfo';

export default ParallelInfo;
